import { FC, useState } from 'react';
import { useNews } from 'store/news';
import { SelectFilter, SelectFilterProps } from 'components/filters';

type Props = Omit<
  SelectFilterProps<string, true>,
  'options' | 'loadingOptions' | 'asyncSearch' | 'onSearch' | 'multiple'
>;

export const NewsFilter: FC<Props> = (props) => {
  const [search, setSearch] = useState('');

  const { data: news, isLoading } = useNews({ search });

  return (
    <SelectFilter
      {...props}
      options={news?.items.map((item) => ({
        key: item.id,
        label: item.name,
      }))}
      loadingOptions={isLoading}
      onSearch={setSearch}
      multiple
      asyncSearch
    />
  );
};
